import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.presentation');
import { OnInit, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-presentation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.presentation/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}`],
})
export class PagePresentationComponent implements OnInit {
    @ViewChild('presentationFrame') presentationFrame: ElementRef;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public goBack() {
        this.service.href('/hub');
    }

    public async fullscreen() {
        if (this.presentationFrame && this.presentationFrame.nativeElement) {
            const iframe = this.presentationFrame.nativeElement;
            if (iframe.requestFullscreen) {
                await iframe.requestFullscreen();
            }
        }
    }

    public openNewTab() {
        window.open('/files/presentation', '_blank');
    }
}

export default PagePresentationComponent;